module.exports = __webpack_public_path__ + "img/5_Private the on market artwork.5d0c9175.svg";